import React from 'react'
import { Link } from "react-router-dom"

export default function Header() {
  return (
    <div className="header-container">

      <Link to="/" >
        <img className="jason-kang" alt="jason-kang" src="/images/jk.png" />
      </Link>
      
      <div className="tags-container">

        <Link to="/" >
          <div className="header-home-container">
        <img className="header-home" alt="home" src="/images/home.png" /> 
          <div className="header-home2">Home</div>
          </div>
        </Link>

        <Link to="/about">
        <div className="header-person-container">
        <img className="header-person" alt="person" src="/images/person.png" /> 
            <div className="header-about">About</div>
          </div>
        </Link>

        
        <Link to="/skills">
        <div className="header-tool-container">
        <img className="header-tool" alt="tool" src="/images/tool.png" /> 
            <div className="header-skills">Skills</div>
          </div>
        </Link>
          
        <Link to="/projects">
        <div className="header-project-container">
        <img className="header-project" alt="project" src="/images/project.png" /> 
            <div className="header-projects">Projects</div>
        </div>
        </Link>
          
        <Link to="/contact">
        <div className="header-contact-container">
        <img className="header-contact" alt="contact" src="/images/contact.png" /> 
            <div className="header-contact2">Contact</div>
            </div>
        </Link>

      </div>
      
    </div>
  )
}
